/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div id="app">
    <router-view />

    <ModalError 
      v-if="isSessionExpired"
      :mostrarExito="isSessionExpired"
      mensajeExito="Tu sesión ha expirado por seguridad. Por favor, inicia sesión nuevamente."
    />
  </div>
</template>

<script>
import ModalError from '@/components/Modales/ModalError.vue'; 

export default {
  name: 'App',
  components: {
    ModalError
  },
  computed: {
    isSessionExpired() {
      return this.$store.state.sessionExpired;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0px;
  scroll-behavior: smooth;
}

.no-scroll {
  overflow: hidden !important;
  position: fixed;
  width: 100%;
}

html {
  scroll-behavior: smooth;
}
</style>

